import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-socials">
        <a href="https://www.facebook.com/share/1HRb4Cuh13/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <i className="fab fa-facebook-f" aria-hidden="true"></i>
        </a>
        {/* <a href="https://twitter.com/srkproduction" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
          <i className="fab fa-twitter" aria-hidden="true"></i>
        </a> */}
        <a href="https://www.instagram.com/srk_production_?igsh=cmM3cnI2eTJiZmZr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <i className="fab fa-instagram" aria-hidden="true"></i>
        </a>
        <a href="https://youtube.com/@srkproductionnashik3257?si=yMVtsH30nv_L99p-" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <i className="fab fa-youtube" aria-hidden="true"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
